import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ChatBubble = createIcon({
  displayName: 'ChatBubble',
  viewBox: '0 0 24 24',
  path: [/*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.9 22a.462.462 0 01-.3-.12.519.519 0 01-.139-.584L6.11 17.08c-2.359-1.186-3.978-3.535-4.109-6.273C2 6.5 6.49 3 12 3c5.51 0 10 3.5 10 7.79s-4.49 7.79-10 7.79c-.621 0-1.231-.044-1.829-.128L5.16 21.92a.46.46 0 01-.26.08zM12 4c-5 0-9 3-9 6.79 0 2.24 1.49 4.34 4 5.62a.512.512 0 01.228.644l-1.309 3.157 4-2.69a.456.456 0 01.403-.059c.511.075 1.104.119 1.707.119h.01c4.999 0 8.999-3 8.999-6.79s-4.04-6.79-9.04-6.79L12 4z",
    clipRule: "evenodd"
  })]
});
//# sourceMappingURL=ChatBubble.js.map